module.exports = __webpack_public_path__ + "img/time-status.8249d0c5.png";